export default
    {
        "url_prod": "https://apiboletodigital.flexcontact.com.br/",
        "url_test": "https://apiboletodigital.xlab.digital/",
        "url_dev": "http://localhost:3001/"
    }